import { SVGProps } from "react";

export default function StepIcon1(props: SVGProps<SVGSVGElement>) {
  return (
<svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 5.66602C3.5 3.45688 5.29086 1.66602 7.5 1.66602H12.6765C13.7373 1.66602 14.7548 2.08744 15.5049 2.83759L17.3284 4.66111C18.0786 5.41126 18.5 6.42867 18.5 7.48954V14.3327C18.5 16.5418 16.7091 18.3327 14.5 18.3327H7.5C5.29086 18.3327 3.5 16.5418 3.5 14.3327V5.66602Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M7.66699 5.83398L14.3337 5.83398" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M7.66699 10H14.3337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M7.66699 14.166H11.0003" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
 );
};

